<div class="fh-form-section" style="gap: 32px" [formGroup]="form">
  <fieldset>
    <legend>Caratteristiche badante richiesta</legend>
    <div class="fh-form-grid" style="justify-items: normal">
      <div style="display: flex; flex-direction: column; gap: 10px;"
        formGroupName="requestedAge">
        <label class="fw-semibold">Età badante</label>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="reqage1">18-35 anni</label>
          <input type="checkbox" id="reqage1"
            formControlName="requestedAgeCluster1">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="reqage2">36-50 anni</label>
          <input type="checkbox" id="reqage2"
            formControlName="requestedAgeCluster2">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="reqage3">51+ anni</label>
          <input type="checkbox" id="reqage3"
            formControlName="requestedAgeCluster3">
        </div>
      </div>
      <div style="display: flex; flex-direction: column; gap: 10px;"
        formGroupName="requestedExp">
        <label class="fw-semibold">Esperienza badante richiesta</label>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="reqexp1">Anziani non autosufficienti</label>
          <input type="checkbox" id="reqexp1"
            formControlName="requestedExpCluster1">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="reqexp2">Anziani autosufficienti</label>
          <input type="checkbox" id="reqexp2"
            formControlName="requestedExpCluster2">
        </div>
      </div>
      <div style="display: flex; flex-direction: column; gap: 10px;">
        <label class="fw-semibold">Disponibilità Badante</label>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label class="label" for="hospital">Assistenza in ospedale</label>
          <input type="checkbox" id="hospital" formControlName="hospital">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label class="label" for="changing">Cambio pannolone</label>
          <input type="checkbox" id="changing" formControlName="changing">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label class="label" for="dayShift">Badante diurna</label>
          <input type="checkbox" id="dayShift" formControlName="dayShift">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label class="label" for="nightShift">Badante notturna</label>
          <input type="checkbox" id="nightShift" formControlName="nightShift">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label class="label" for="license">Patente</label>
          <input type="checkbox" id="license" formControlName="license">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label class="label" for="car">Automunita</label>
          <input type="checkbox" id="car" formControlName="car">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label class="label" for="coliving">Disp. Convivenza</label>
          <input type="checkbox" id="coliving" formControlName="coliving">
        </div>
      </div>
      <div style="display: flex; flex-direction: column; gap: 10px;">
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;margin-top: 32px;">
          <label class="label" for="walking">Accompagnare la persona alle visite
            a Piedi</label>
          <input type="checkbox" id="walking" formControlName="walking">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label class="label" for="taxiNoCar">Accompagnare la persona alle
            visite con Auto Fornita dalla
            Famiglia</label>
          <input type="checkbox" id="taxiNoCar" formControlName="taxiNoCar">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label class="label" for="taxi">Accompagnare la persona alle visite
            con Auto Propria</label>
          <input type="checkbox" id="taxi" formControlName="taxi">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label class="label" for="cleaning">Provvedere all'igiene completo
            della persona</label>
          <input type="checkbox" id="cleaning" formControlName="cleaning">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label class="label" for="relocation">Disp. Trasferte</label>
          <input type="checkbox" id="relocation" formControlName="relocation">
        </div>
      </div>
      <div class="fh-form-grid"
        style="justify-items: normal; grid-column: 1/3;">
        <div style="display: flex; flex-direction: column; gap: 10px;">
          <label class="fw-semibold">Formazione Badante</label>
          <div class="fh-form-input-field"
            style="grid-template-columns: 1fr 20px;">
            <label class="label" for="glycemia">Controllo glicemia con apposito
              apparecchio</label>
            <input type="checkbox" id="glycemia" formControlName="glycemia">
          </div>
          <div class="fh-form-input-field"
            style="grid-template-columns: 1fr 20px;">
            <label class="label" for="injections">Iniezioni sicure</label>
            <input type="checkbox" id="injections" formControlName="injections">
          </div>
        </div>
        <div style="display: flex; flex-direction: column; gap: 10px;">
          <div class="fh-form-input-field"
            style="grid-template-columns: 1fr 20px;margin-top: 32px;">
            <label class="label" for="dressings">Medicazioni</label>
            <input type="checkbox" id="dressings" formControlName="dressings">
          </div>
          <div class="fh-form-input-field"
            style="grid-template-columns: 1fr 20px;">
            <label class="label" for="technology">Utilizzo di apparecchi
              tecnologici es. ricette elettroniche</label>
            <input type="checkbox" id="technology" formControlName="technology">
          </div>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <legend>Caratteristiche incarico</legend>
    <div class="fh-form-grid">
      <div class="fh-form-input-field">
        <label class="fw-semibold" for="iniziostimato">Inizio stimato</label>
        <input type="date" id="iniziostimato" formControlName="starting">
      </div>
      <div class="fh-form-input-field">
        <label class="fw-semibold" for="durataimpegno">L'anziano avrebbe bisogno
          fino a</label>
        <input type="date" id="durataimpegno"
          formControlName="estimatedLasting">
      </div>
      <div class="fh-form-input-field">
        <label class="fw-semibold" for="serviceStart">Da quando</label>
        <input type="text" id="serviceStart" formControlName="serviceStart"
          readonly>
      </div>
      <div class="fh-form-input-field">
        <label class="fw-semibold" for="serviceDuration">Per quanto
          tempo</label>
        <input type="text" id="serviceDuration"
          formControlName="serviceDuration" readonly>
      </div>
      <div class="fh-form-input-field" style="grid-template-columns: 1fr 20px;">
        <label class="fw-semibold" for="continuousJob">Lavoro
          continuativo</label>
        <input type="checkbox" id="continuousJob"
          formControlName="continuousJob">
      </div>
      <div class="fh-form-input-field" style="grid-template-columns: 1fr 20px;">
        <label class="fw-semibold" for="moreThanOne">Numero di anziani maggiore
          di 1</label>
        <input type="checkbox" id="moreThanOne" formControlName="moreThanOne">
      </div>
      <div class="fh-form-input-field" style="grid-template-columns: 1fr 20px;">
        <label class="fw-semibold" for="badWorkHours">Orari scomodi - <span
            style="font-size: 13px; color: grey;">A
            chiamata,
            Periodo breve inferiore al mese, tra le 20 e le 7.30; solo sabato o
            Domenica; meno o uguale 3 ore/ al
            giorno</span></label>
        <input type="checkbox" id="badWorkHours" formControlName="badWorkHours">
      </div>
      <div class="fh-form-input-field" style="grid-template-columns: 1fr 20px;">
        <label class="fw-semibold" for="inconvenientLocation">Luogo di lavoro
          scomodo o Scarsa densità popolazione</label>
        <input type="checkbox" id="inconvenientLocation"
          formControlName="inconvenientLocation">
      </div>
      <div class="fh-form-input-field" style="grid-column: span 2;">
        <div style="grid-column: span 2;">
          <label class="fw-semibold" style="display: block;"
            for="descrizioneimpegno">Descrizione impegno - <span
              style="font-size: 13px; color: grey;">"Serve una badante per..."</span></label>
          <textarea rows="6" type="text" id="descrizioneimpegno"
            maxlength="2048"
            formControlName="requestDescription"
            style="width: 100%;"></textarea>
        </div>
      </div>
    </div>
  </fieldset>
  @if (inputData !== undefined) {
  <app-request-pricing [province]="provincia"
    [badWorkHoursInput]="form.get('badWorkHours')!.value"
    [handicapInput]="false"
    [moreThanOneInput]="form.get('moreThanOne')!.value"
    [continuousJobInput]="form.get('continuousJob')!.value"
    [inconvenientLocationInput]="form.get('inconvenientLocation')!.value"
    [request]="inputData"
    [reqService]="reqService"
    (pricing)="updatePricing($event)"></app-request-pricing>
  }
  <fieldset>
    <legend>Orari di lavoro</legend>
    <div class="fh-form-grid" style="justify-items: normal">
      <div style="display: flex; flex-direction: column; gap: 10px;"
        formGroupName="days">
        <label class="fw-semibold">Giorni lavorativi</label>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="mon">Lunedì</label>
          <input type="checkbox" id="mon" formControlName="mon">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="tue">Martedì</label>
          <input type="checkbox" id="tue" formControlName="tue">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="wed">Mercoledì</label>
          <input type="checkbox" id="wed" formControlName="wed">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="thu">Giovedì</label>
          <input type="checkbox" id="thu" formControlName="thu">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="fri">Venerdì</label>
          <input type="checkbox" id="fri" formControlName="fri">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="sat">Sabato</label>
          <input type="checkbox" id="sat" formControlName="sat">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="sun">Domenica</label>
          <input type="checkbox" id="sun" formControlName="sun">
        </div>
      </div>

      <div style="display: flex; flex-direction: column; gap: 10px;"
        formGroupName="hours">
        <label class="fw-semibold">Fascia oraria</label>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="mor">Mattino</label>
          <input type="checkbox" id="mor" formControlName="mor">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="aft">Pomeriggio</label>
          <input type="checkbox" id="aft" formControlName="aft">
        </div>
        <div class="fh-form-input-field"
          style="grid-template-columns: 1fr 20px;">
          <label for="eve">Sera</label>
          <input type="checkbox" id="eve" formControlName="eve">
        </div>
      </div>
    </div>
  </fieldset>
</div>
